<template>
  <div>
    <CRow>
      <CCol sm="12">
        <BrandsTable
          :items="brands"
          hover
          striped
          border
          small
          fixed
          caption="Marcas"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BrandsTable from '../../components/brands/BrandsTable.vue'
import brands from '../../services/brands';
import store from '../../store'

export default {
  name: 'Brands',
  components: { BrandsTable },
  data: function () {
		return {
            brands: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await brands.get();

    if(response.type == "success"){
      this.brands = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.brands = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
